import { createContext } from "react";

import { UserToken } from "@src/common/helpers/userToken";
import { NotificationsData } from "@src/modules/App/Notifications/hooks/useNotificationsCore";
import { DicomViewerVisibility } from "@src/modules/DicomViewer/hooks/useDicomViewerVisibility";

export interface AppContextType {
  userToken: UserToken | null;
  notifications: NotificationsData;
  dicomViewer: DicomViewerVisibility;
}

const AppContext: React.Context<AppContextType> = createContext<AppContextType>(
  {} as AppContextType,
);

export default AppContext;
